









































Currency = require 'models/currency.coffee'

module.exports =
  name: 'account_stats'
  props:
    display:
      default: 'all'
      validator: (value) -> value == 'all' || value == 'accounts' || value == 'envelopes'
    display_title:
      default: true
      type: Boolean
    display_total:
      default: false
      type: Boolean
  components:
    balance: require('components/inside/elements/balance.vue').default
  computed:
    accounts: -> @$store.getters.accounts_in_budget
    by_currencies: ->
      accs = _.groupBy @accounts, 'currency'
      result = _.map accs, (accounts, currency) -> { currency: currency, sum: _.sumBy(accounts, 'balance') }
      result.filter (stat) ->
        sum = stat.sum
        sum = Math.round(sum) if Currency.get(stat.currency).precision == 0
        sum != 0
    total: -> _.sumBy @accounts, (acc) => acc.universalBalance(@$store.getters.default_currency)
    has_different_currencies: -> Object.keys(@by_currencies).length > 1

